export class KeyValuePair {
  key: string;
  value: string;

  constructor(key: string, value: string){
    this.key = key;
    this.value= value;
  }
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/key-value-pair.ts